import { DocumentDuplicateIcon, TvIcon, XMarkIcon } from '@heroicons/react/16/solid';
import React, { useEffect, useState } from 'react';

export default function SubscribePodcast({ platforms, rss, isDark, podcast, showSubscribe, onClose }) {

    const bgColor = () => isDark ? " bg-[#535860] " : " bg-white "
    const textColor = () => isDark ? " text-gray-200 " : " text-black "
    const textColorLight = () => isDark ? " text-gray-300 " : " text-gray-500 "
    const buttons = () => isDark ? "#B2B9C4" : "black"

    const shareUrl = rss;
    const [clicked, setClicked] = useState(false)
    return (
        <div className={bgColor() + ` shadow-lg w-90 sm:w-2/5 z-10 absolute my-1 mx-1 bottom-16 right-0 overflow-y-scroll overflow-x-hidden transition-opacity duration-500 p-4 rounded-md ` + (showSubscribe ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none')} >
            <div className={'relative flex-col justify-center' + textColor()}>
                <div className='cursor-pointer text-base absolute right-2' onClick={onClose}>
                    <XMarkIcon color={buttons()} className='w-6 h-6' />
                </div>
                <div className='text-lg  font-bold'>Subscribe</div>
                <div className='text-sm font-normal'>{podcast.title}</div>
                <div className={"text-center text-sm font-normal" + textColorLight()}>
                    <div className="grid grid-cols-4 my-4">
                        {platforms.map(element => {
                            return (<a
                                href={element.uri}
                                target="_blank"
                                className="flex p-1 m-[0.1rem] w-auto rounded-full bg-[#ffffff10] justify-center"
                            >
                                <img src={element.image} className='h-6 w-6' />
                            </a>)
                        })}
                    </div>
                </div>
                <div className={'flex flex-row text-md space-x-2  items-center cursor-pointer' + textColorLight()} onClick={() => {
                    if (clicked) return;
                    navigator.clipboard.writeText(shareUrl);
                    setClicked(true)
                    setTimeout(() => {
                        setClicked(false)
                    }, 1000)
                }}>
                    <DocumentDuplicateIcon className='h-5 w-5' />
                    <div className='hover:underline'>{clicked ? "RSS Copied" : "Copy RSS"}</div>
                </div>
            </div>
        </div>
    )
}


